import { render, staticRenderFns } from "./CtcWidgetFormatPicker.vue?vue&type=template&id=8dc2c11c&scoped=true&"
import script from "./CtcWidgetFormatPicker.vue?vue&type=script&lang=js&"
export * from "./CtcWidgetFormatPicker.vue?vue&type=script&lang=js&"
import style0 from "./CtcWidgetFormatPicker.vue?vue&type=style&index=0&id=8dc2c11c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc2c11c",
  null
  
)

export default component.exports